/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_Pick_HintInputs */

const cs_signing_pick_hint = /** @type {(inputs: Signing_Pick_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kliknutím načtete nedávná oprávněná PDF, nebo pište pro hledání podle názvu.`)
};

const en_signing_pick_hint = /** @type {(inputs: Signing_Pick_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click to load recent eligible PDFs, or type to search by name.`)
};

/**
* | output |
* | --- |
* | "Click to load recent eligible PDFs, or type to search by name." |
*
* @param {Signing_Pick_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const signing_pick_hint = /** @type {((inputs?: Signing_Pick_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_Pick_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signing_pick_hint(inputs)
	return cs_signing_pick_hint(inputs)
});